import { Component, OnInit, OnDestroy, HostListener, NgZone } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { HttpClient } from '@angular/common/http';
import { bmxurl } from 'src/globals';
import { environment } from 'src/environments/environment';
import { AppComponent } from '../app.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BusyService } from '../_services/busy.service';
import { GlobalService } from '../_services/global.service';
import { MessageService } from 'primeng/api';
import { cBookingnumbers } from 'src/types/bookingnumbers';
import { bookingnumbers_returndata } from 'src/types/bookingnumbers_retunrdata';
import { session } from 'src/types/session';
import { session_returndata } from 'src/types/session_returndata';
import { cCounterValues } from 'src/types/countervalues';
import { countervalues_returndata } from 'src/types/countervalues_returndata';

@Component({
  selector: 'app-ataglance',
  templateUrl: './ataglance.component.html',
  styleUrls: ['./ataglance.component.css']
})
export class AtaglanceComponent implements OnInit, OnDestroy {

  ListBookings: any[];
  ListBookingsGlobal: any[];
  Bookings: any;
  data: any;
  options: any;
  hubConnection: HubConnection;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  showStarted: boolean = false;
  bookingnumbers: cBookingnumbers[];
  BookingDate: Date;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;
  startdate: string = "";
  httpResponse: any;
  bookingnumbersfiltered: any;
  UseCounters: boolean = false;
  Counters: cCounterValues = {
    venueid: "",
    participants: 0,
    nonparticipants: 0,
    timeremaining: 0,
    timeusedup: 0,
    total: 0
  };
  disabledDatesArr: Date[] = [];

  scanBuffer: string = '';
  scanTimer: any = null;

  showScanDialog: boolean = false;
  scannedBooking: any = null;

  //Taking a payment from that dialog, and the card terminal behind it.
  showScanPayment: boolean = false;
  PaymentTypes: any[] = [];
  selectedPayment: any = null;
  paymentAmount: number = 0;
  paymentTypeValid: boolean = true;
  paymentValueValid: boolean = true;
  paymentButtonLocked: boolean = false;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  showTerminalWaiting: boolean = false;
  showTerminalBusyDialog: boolean = false;
  terminalPaymentIntentId: string = "";
  terminalPaymentResolved: boolean = false;
  terminalPollingIntervalId: any = null;
  pendingTerminalId: string = "";


  PreviousHubs: string[] = [];

  sessionArray: session[] = []

  ShowCounterStrip: boolean = true;
  searchCriteria: string = "";
  atAGlanceFigures: { parties: number; partyadmissions: number; nonpartyadmissions: number } | null = null;
  ShowAtAGlanceFigures: boolean = true;
  ShowNewBookingsOnAtAGlance: boolean = false;
  BookingsToAcknowledgeCount: number = 0;

  screenwidth: number = window.innerWidth;
  screenheight: number = window.innerHeight;

  get useMobileView(): boolean {
    if (this.screenwidth <= 768) return true;
    return this.screenwidth <= 1024 && this.screenheight > this.screenwidth;
  }

  get isBookingDateToday(): boolean {
    if (!this.BookingDate) return false;
    const today = new Date();
    return this.BookingDate.getFullYear() === today.getFullYear()
      && this.BookingDate.getMonth() === today.getMonth()
      && this.BookingDate.getDate() === today.getDate();
  }

  constructor(private route: ActivatedRoute,
    private http: HttpClient, 
    private appComp: AppComponent, 
    private router: Router, 
    private messageService: MessageService, 
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService,
    private ngZone: NgZone) { 

        // this.disabledDatesArr.push(new Date(2025, 6, 11)); 
        // this.disabledDatesArr.push(new Date(2025, 6, 17)); 
        // this.disabledDatesArr.push(new Date(2025, 6, 23));
  }

  monthchange(){
  }

  doneDate(){
    this.loadgrid()

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  getSearchResults() {
    if (this.searchCriteria.trim() === '') return;
    localStorage.removeItem("SearchResults");
    let crit = this.searchCriteria.trim().replace("/", "-").replace("/", "-");
    crit = encodeURIComponent(crit);
    this.searchCriteria = "";
    this.router.navigate(['/search'], { queryParams: { crit: crit } });
  }

  dateChange(num)
  {
    this.BookingDate = this.addDays(new Date(this.BookingDate), num);
    this.doneDate();

  }

  bookingblock(inTime){
    localStorage.setItem("AAGData", this.stringifyDate(this.BookingDate) + "T" + inTime + ":00.000");
    localStorage.setItem("ataglance", "TRUE");
    this.router.navigate(['/bookingblock/' + this.stringifyDate(this.BookingDate) + "T" + inTime + ":00.000"]);
  }

  stringifyDate(date: Date): string
  {
    let returnString = "";

    returnString = date.getFullYear() + "-" +  ('00' + (Number(date.getMonth()) + 1)).slice(-2) + "-" +  ('00' + date.getDate()).slice(-2);

    return returnString;
  }

  admitAll(time, id, started){
    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let NewDate = BookingDateDay + BookingDateMonth + BookingDateYear;

    //let timeChosen = ('00' + this.BookingDate.getHours()).slice(-2) + ('00' + this.BookingDate.getMinutes()).slice(-2);
    let timeChosen = time.replace(":", "");

    this.http.get(bmxurl + "/groupcheckin/" + this.VenueID + "/" + NewDate + "/" + timeChosen).subscribe(response => {
      this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.loadgrid();
          this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers admitted for this time slot.'});
        }
        }, error => {
          this.messageService.add({severity:'error', summary:'Could not admit all customers', detail:error.messages});
      })

      this.startSession(time, id, false);
  }

  leaveAll(time, id, started){
    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let NewDate = BookingDateDay + BookingDateMonth + BookingDateYear;

    //let timeChosen = ('00' + this.BookingDate.getHours()).slice(-2) + ('00' + this.BookingDate.getMinutes()).slice(-2);
    let timeChosen = time.replace(":", "");

    this.http.get(bmxurl + "/groupcheckout/" + this.VenueID + "/" + NewDate + "/" + timeChosen).subscribe(response => {
      this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.loadgrid();
          this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers left for this time slot.'});
        }
        }, error => {
          this.messageService.add({severity:'error', summary:'Could not leave all customers', detail:error.messages});
      })

      //this.startSession(time, id, true);
  }

  startSession(time, id, started){
    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let NewDate = new Date(BookingDateYear + "-" + BookingDateMonth + "-" + BookingDateDay + " " + time + ":00");

    //let SessionDate = new Date(BookingDateYear + "-" + BookingDateMonth + "-" + BookingDateDay + " " + "00:00:00");

    //Check if NewDate is today
    // let TodayDateYear = new Date().getFullYear(); 
    // let TodayDateMonth = new Date().getMonth() + 1;
    // let TodayDateDay = new Date().getDate();
    
    //let TodaysDate = new Date(TodayDateYear + "-" + TodayDateMonth + "-" + TodayDateDay + " " + "00:00:00");

    // if(SessionDate.getTime() != TodaysDate.getTime())
    // {
    //   this.messageService.add({severity:'error', summary:'Cannot start or stop session', detail:"You cannot start or stop a session that's not for today."});
    //   return;
    // }

    if(id == null)
    {
      let NewSession : session = {
        id: null,
        venueid: this.VenueID,
        datetime: NewDate,
        started: true
      }

      this.http.post<any>(bmxurl + "/CountersSession", NewSession).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Started', detail:'This session has been started.'});
            this.loadgrid();
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Could not start or stop this session', detail:this.httpResponse.messages[0]});
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Could not start or stop this session', detail:error.messages});
        })
    }
    else
    {
      let NewSession : session = {
        id: id,
        venueid: this.VenueID,
        datetime: NewDate,
        started: !started
      }

      this.http.post<any>(bmxurl + "/CountersSession", NewSession).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            if(started)
            {
              this.messageService.add({severity:'success', summary:'Started', detail:'This session has been Stopped.'});
              this.loadgrid();
            }
            else
            {
              this.messageService.add({severity:'success', summary:'Stopped', detail:'This session has been Started.'});
              this.loadgrid();
            }
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Could not start or stop this session', detail:this.httpResponse.messages[0]});
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Could not start or stop this session', detail:error.messages});
        })
    }

  }

  loadgrid()
  {
    //Get date for today
    let TodayDateYear = new Date().getFullYear().toString().substr(-2);
    let TodayDateMonth = ('00' + (new Date().getMonth() + 1)).slice(-2);
    let TodayDateDay = ('00' + new Date().getDate()).slice(-2);

    let todayDate = TodayDateDay + TodayDateMonth + TodayDateYear;

    //get countersessions for today
    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    if(todayDate == dateChosen)
    {
      this.ShowCounterStrip = true;
    }
    else
    {
      this.ShowCounterStrip = false;
    }

    this.http.get(bmxurl + "ataglancefigures/" + this.VenueID + "/" + dateChosen + "/false").subscribe(response => {
      this.atAGlanceFigures = (response as any).data ?? null;
    }, () => { this.atAGlanceFigures = null; });

    //this.busyService.busy();
    this.http.get(bmxurl + "BookingListMinGrouped/" + this.VenueID + "/" + dateChosen + "/false").subscribe(response => {
      try{
        this.bookingnumbers = (response as bookingnumbers_returndata).data;

        let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
        let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);
    
        let BookingDateYearForCounters = this.BookingDate.getFullYear().toString();
    
        let venueDate = this.VenueID + "_" + BookingDateDay + BookingDateMonth + BookingDateYearForCounters;
    
        this.http.get(bmxurl + "CountersSessionList/" + venueDate).subscribe(response => {
          this.sessionArray = (response as session_returndata).data;
          this.bookingnumbers.forEach(bn => {
            if(this.sessionArray != null && this.sessionArray.length > 0)
            {
              this.sessionArray.forEach(session => {
                //add time to dateChosen
                let BookingDateYear = "20" + dateChosen.substring(4,8);
                let BookingDateMonth = dateChosen.substring(2,4);
                let BookingDateDay = dateChosen.substring(0,2);
                
                let NewDate = new Date(BookingDateYear + "-" + BookingDateMonth + "-" + BookingDateDay + " " + bn.time + ":00");

                if((new Date(session.datetime).getTime()) == (new Date(NewDate).getTime()))
                {
                  bn.id = session.id;
                  bn.started = session.started;
                }
              });
            }
          });

          this.bookingnumbersfiltered = this.bookingnumbers.filter(bn => bn.started == false || bn.started == null);

          if(!this.isBookingDateToday)
          {
            this.stopStartedSessions(this.sessionArray);
          }

          //Get the number for counters
          this.http.get(bmxurl + "todayscounters/" + this.VenueID).subscribe(response => {
            this.Counters = (response as countervalues_returndata).data;
          });

        }, error => {
          this.messageService.add({severity:'error', summary:'Error getting sessions', detail: 'An error occurred getting sessions'});
        });

      }
      catch{
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
      }
      finally{
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
      this.busyService.idle();
    });
  }

  loadAcknowledgeCount() {
    if (!this.ShowNewBookingsOnAtAGlance) {
      this.BookingsToAcknowledgeCount = 0;
      return;
    }

    this.http.get(bmxurl + "acknowledgelist/" + this.VenueID).subscribe(response => {
      const data = (response as any).data;
      this.BookingsToAcknowledgeCount = data ? data.length : 0;
    }, () => { this.BookingsToAcknowledgeCount = 0; });
  }

  viewBookingsToAcknowledge() {
    this.router.navigateByUrl("/bookingstoacknowledge");
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    addEventListener("resize", () => {
      this.screenwidth = window.innerWidth;
      this.screenheight = window.innerHeight;
    });

    this.UseCounters = localStorage.getItem("UseCounters") == "true" ? true : false;
    this.ShowAtAGlanceFigures = localStorage.getItem("ShowAtAGlanceFigures") != "false";
    this.ShowNewBookingsOnAtAGlance = localStorage.getItem("ShowNewBookingsOnAtAGlance") == "true";

    this.BookingDate = new Date();
    this.startdate = this.route.snapshot.paramMap.get('startdate');

    if(this.startdate != null)
    {
      this.BookingDate = new Date(this.startdate);
    }

    this.auth.getAccessTokenSilently().subscribe(tokenReturned => {
      this.hubConnection = new HubConnectionBuilder()
	    .withUrl(environment.servicestarget + "/venue/" + this.VenueID, { 
		  accessTokenFactory: () => tokenReturned 
	  }).build();

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

    this.PreviousHubs.push(BookingEventDate);

    this.hubConnection.start();

    this.hubConnection.off(BookingEventDate);

    this.hubConnection.on(BookingEventDate, data => {
      this.loadgrid();
    });

    this.hubConnection.on("countervalues", data => {
      //this.messageService.add({severity:'success', summary:'Booking Made', detail: 'COUNTERS HAVE CHANGED'});
      this.Counters = data;
    });

    });
    
    this.loadgrid();
    this.loadAcknowledgeCount();

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    
    this.options = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
            legend: {
                labels: {
                    color: textColor
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: textColorSecondary,
                    font: {
                        weight: 500
                    }
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            },
            y: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false
                }
            }

        }
    };

  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const target = event.target as HTMLElement;

    if (event.key === 'Enter') {
      if (this.scanBuffer.length > 0) {
        event.preventDefault();
        event.stopPropagation();
        this.handleScan(this.scanBuffer);
      }
      this.scanBuffer = '';
      if (this.scanTimer) { clearTimeout(this.scanTimer); this.scanTimer = null; }
      return;
    }

    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return;
    }

    if (event.key.length !== 1) { return; }

    // Blur focused buttons so the scan's Enter key doesn't also trigger them
    if (target.tagName === 'BUTTON') {
      target.blur();
    }

    if (this.scanTimer) { clearTimeout(this.scanTimer); }
    this.scanBuffer += event.key;
    this.scanTimer = setTimeout(() => { this.scanBuffer = ''; this.scanTimer = null; }, 100);
  }

  //The Find button beside the date. A till with no scanner works off the day's list instead,
  //which carries the same admit and leave actions the scan dialog does.
  openBookingList() {
    this.router.navigateByUrl("/ataglancebookings/" + this.stringifyDate(this.BookingDate));
  }

  handleScan(bookingIdHR: string) {
    const ref = bookingIdHR.trim().replace('#','');
    if (ref.length < 3) { return; }

    //A scanner gives the sales ID printed on the ticket, not the booking's internal id, so the
    //reference is looked up the way the Sales ID box in the header does.
    const bookingRefPattern = /^[a-zA-Z]{3}-d{6}-[a-zA-Z0-9]{6}$/;

    //A cancelled ticket should still be found, so an exact reference looks past disabled too.
    const showDisabled = bookingRefPattern.test(ref);

    this.http.get(bmxurl + "Booking/Search/" + this.VenueID + "/" + encodeURIComponent(ref) + "/true").subscribe(response => {
      const result = response as any;
      const found: any[] = (result != null && result.succeeded ? result.data : null) ?? [];

      //A search matches on name and package as well, so the reference itself wins. Falling back
      //to a single result covers a venue whose barcodes hold something else.
      const match = found.find(booking => (booking.bookingIdHR ?? "").toLowerCase() == ref.toLowerCase())
        ?? (found.length == 1 ? found[0] : null);

      if (match == null) {
        this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No booking found for reference: ' + ref });
        return;
      }

      if (!this.isForToday(match.startTime)) {
        this.messageService.add({ severity: 'warn', summary: 'Not Today', detail: 'This booking is for ' + this.readableBookingDate(match.startTime) + ', not today.' });
        return;
      }

      this.loadScannedBooking(match.bookingId);
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Scan Error', detail: 'Could not find booking for: ' + ref });
    });
  }

  //A booking is held in UTC and the venue reads it as its own clock, so the day is taken from
  //the UTC parts rather than the browser's.
  private isForToday(startTime: any): boolean {
    if (startTime == null) { return false; }

    const start = new Date(startTime);
    if (isNaN(start.getTime())) { return false; }

    const now = new Date();

    return start.getUTCFullYear() == now.getFullYear()
      && start.getUTCMonth() == now.getMonth()
      && start.getUTCDate() == now.getDate();
  }

  private readableBookingDate(startTime: any): string {
    const start = new Date(startTime);

    return ('00' + start.getUTCDate()).slice(-2)
      + '/' + ('00' + (start.getUTCMonth() + 1)).slice(-2)
      + '/' + start.getUTCFullYear();
  }

  //The search only returns enough to list a booking. The allergy, the admissions and the
  //customer's details come off the full booking, which is fetched by its own id.
  private loadScannedBooking(bookingId: string) {
    this.http.get(bmxurl + "booking/" + this.VenueID + "/" + bookingId).subscribe(response => {
      const result = response as any;

      if (!result.succeeded || result.data == null) {
        this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'That booking could not be opened.' });
        return;
      }

      this.scannedBooking = result.data;

      let allergy = this.scannedBooking.allergytext ?? this.scannedBooking.allergy ?? "";

      if (allergy == "" && this.scannedBooking.questionnaire != null && this.scannedBooking.questionnaire.bookingquestions != null) {
        this.scannedBooking.questionnaire.bookingquestions.forEach(question => {
          if (question.questiontype == "ALLERGY"
            && question.answers != null
            && question.answers.allergyanswer != null
            && question.answers.allergyanswer.allergypresent) {
            allergy = question.answers.allergyanswer.allergytext;
          }
        });
      }

      this.scannedBooking.allergy = allergy;

      let admissiontext = "";

      if (this.scannedBooking.resources != null
        && this.scannedBooking.resources[0] != null
        && this.scannedBooking.resources[0].admissions != null) {
        this.scannedBooking.resources[0].admissions.forEach(admission => {
          if (admission.noofpeople > 0) {
            admissiontext += admission.name + " x " + admission.noofpeople + ", ";
          }
        });

        if (admissiontext.length > 2) {
          admissiontext = admissiontext.substring(0, admissiontext.length - 2);
        }
      }

      this.scannedBooking.admissiontext = admissiontext;
      this.scannedBooking.cancelreason = "";
      this.showScanDialog = true;

      if (this.scannedBookingIsDisabled()) {
        this.loadCancellationReason(bookingId);
      }
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Scan Error', detail: 'Could not open that booking.' });
    });
  }

  //Cancelling a booking does not put the reason on the booking itself - it is written into the
  //booking history as "This Booking was disabled for the following reason: ...", so the most
  //recent of those is what the banner shows. Fetched after the dialog is already up, so a slow
  //history call does not hold up the person on the counter.
  private loadCancellationReason(bookingId: string) {
    this.http.get(bmxurl + "history/" + bookingId).subscribe(response => {
      const result = response as any;

      if (!result.succeeded || result.data == null) { return; }

      const marker = "disabled for the following reason:";

      const items = result.data
        .filter((item: any) => (item.historyitem ?? "").toLowerCase().includes(marker))
        .sort((a: any, b: any) => new Date(b.itemdatetime).getTime() - new Date(a.itemdatetime).getTime());

      if (items.length == 0 || this.scannedBooking == null) { return; }

      const text: string = items[0].historyitem;
      const reason = text.substring(text.toLowerCase().indexOf(marker) + marker.length).trim();

      this.scannedBooking.cancelreason = reason;
    }, () => {});
  }

  //Whether everyone on the booking is already in, which decides whether the dialog offers to
  //admit them or to mark them as having left.
  scannedBookingIsAdmitted(): boolean {
    return this.scannedBooking != null && this.scannedBooking.checkedin === true;
  }

  //A cancelled booking still scans, and it is more useful to say so than to say nothing - but
  //nobody is admitted on it. The payload is not consistent about the capital, so both are read.
  scannedBookingIsDisabled(): boolean {
    return this.scannedBooking != null
      && (this.scannedBooking.disabled === true || this.scannedBooking.Disabled === true);
  }

  editScannedBooking() {
    if (this.scannedBooking == null) { return; }

    const bookingId = this.scannedBooking.bookingId;
    this.showScanDialog = false;
    this.scannedBooking = null;

    this.router.navigateByUrl("/editbooking/" + bookingId);
  }

  admitScannedBooking() {
    if (this.scannedBooking == null) { return; }

    if (this.scannedBookingIsDisabled()) {
      this.messageService.add({ severity: 'error', summary: 'Cancelled', detail: 'This booking has been cancelled and cannot be admitted.' });
      return;
    }

    //A booking with a waiver still to sign is sent to the waiver screen rather than admitted
    //from here.
    if (this.scannedBooking.haswaiver) {
      this.showScanDialog = false;
      this.router.navigate(['/managewaivers', this.scannedBooking.bookingId], {
        queryParams: { returnDate: this.scannedBooking.startTime }
      });
      return;
    }

    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + this.scannedBooking.bookingId).subscribe(response => {
      const result = response as any;
      if (result.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Admitted', detail: "All customers have been marked as 'admitted' for this booking." });
        this.closeScanDialog();
        this.loadgrid();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Not Admitted', detail: 'An error occurred admitting all customers for this booking' });
      }
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Not Admitted', detail: 'An error occurred admitting all customers for this booking' });
    });
  }

  //The other half of the same switch, so a ticket scanned by mistake can be put back.
  leaveScannedBooking() {
    if (this.scannedBooking == null) { return; }

    this.http.get(bmxurl + "BookingCheckout/" + this.VenueID + "/" + this.scannedBooking.bookingId).subscribe(response => {
      const result = response as any;
      if (result.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Left', detail: "All customers have been marked as having left this booking." });
        this.closeScanDialog();
        this.loadgrid();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Not Updated', detail: 'An error occurred checking out this booking' });
      }
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Not Updated', detail: 'An error occurred checking out this booking' });
    });
  }

  closeScanDialog() {
    this.showScanDialog = false;
    this.scannedBooking = null;
  }

  //#region Taking a payment from the scanned-booking dialog
  //This mirrors the payment panel in Edit Booking, card terminal included: the same
  //StripeTerminalPaymentInit call, the same wait on the venue hub for the payment intent, the
  //same ten-second poll as a backstop, and the same busy-terminal recovery.

  openScanPayment() {
    if (this.scannedBooking == null) { return; }

    this.doPaymentTypes();

    this.selectedPayment = null;
    this.paymentAmount = this.scannedBooking.outstanding;
    this.paymentTypeValid = true;
    this.paymentValueValid = true;
    this.paymentButtonLocked = false;
    this.showScanPayment = true;
  }

  closeScanPayment() {
    this.showScanPayment = false;
    this.selectedPayment = null;
  }

  doPaymentTypes() {
    const cached = localStorage.getItem("PaymentTypes");

    if (cached) {
      this.PaymentTypes = JSON.parse(cached).filter(pt => pt.system == false);
      return;
    }

    this.http.get(bmxurl + "paymenttypes").subscribe(response => {
      const all = (response as any).data;
      localStorage.setItem("PaymentTypes", JSON.stringify(all));
      this.PaymentTypes = all.filter(pt => pt.system == false);
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Failure', detail: 'Failed to get Payment Types.' });
    });
  }

  takeScanPayment() {
    if (this.scannedBooking == null) { return; }

    this.paymentValueValid = this.paymentAmount != null && this.paymentAmount > 0;
    this.paymentTypeValid = this.selectedPayment != null;

    if (!this.paymentValueValid || !this.paymentTypeValid) { return; }

    this.paymentButtonLocked = true;

    //A card payment goes to the reader when the till has one set up for this venue. Without one
    //it is recorded the way cash is, which is what a machine standing on its own needs.
    const terminalId = localStorage.getItem("GeneralTerminalName_" + this.VenueID) ?? '';

    if (this.selectedPayment.name.toLowerCase().includes('card') && terminalId) {
      this.connectTerminalHub(terminalId);
      return;
    }

    const newPayment: any = {
      id: null,
      PaymentId: null,
      BookingId: this.scannedBooking.bookingId,
      bookingIdHR: this.scannedBooking.bookingIdHR,
      method: this.selectedPayment.name,
      paymenttypeid: this.selectedPayment.id,
      amount: this.paymentAmount,
      paymentDate: new Date,
      disabled: false,
      venueid: this.VenueID,
      refunds: null,
      balance: this.paymentAmount,
      paymenttype: "booking",
      currency: this.CurrencySymbol,
      tillname: null
    };

    //The endpoint takes the whole booking with the new payment on it, the same as Edit Booking.
    this.scannedBooking.payments = [newPayment];
    this.scannedBooking.inProgress = false;

    this.http.post(bmxurl + "/Payment", this.scannedBooking).subscribe(response => {
      const result = response as any;

      if (result.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Paid', detail: 'Payment added to this booking.' });
        this.afterScanPayment(result.data);
      }
      else {
        this.paymentButtonLocked = false;
        this.messageService.add({ severity: 'error', summary: 'Not Paid', detail: result.messages });
      }
    }, () => {
      this.paymentButtonLocked = false;
      this.messageService.add({ severity: 'error', summary: 'Not Paid', detail: 'An error occurred taking this payment.' });
    });
  }

  //The booking that comes back carries the new balance, so the scanned dialog behind it is
  //brought up to date rather than closed - whoever is on the counter still has to admit them.
  //The allergy and admissions text are worked out on the way in, so they are carried across.
  private afterScanPayment(booking: any) {
    const allergy = this.scannedBooking == null ? "" : this.scannedBooking.allergy;
    const admissiontext = this.scannedBooking == null ? "" : this.scannedBooking.admissiontext;

    this.scannedBooking = booking;
    this.scannedBooking.allergy = allergy;
    this.scannedBooking.admissiontext = admissiontext;

    this.paymentAmount = booking.outstanding;
    this.selectedPayment = null;
    this.paymentButtonLocked = false;
    this.showScanPayment = false;

    this.loadgrid();
  }

  connectTerminalHub(terminalId: string): void {
    this.terminalPaymentResolved = false;
    this.terminalPaymentIntentId = '';
    this.showTerminalWaiting = true;
    this.pendingTerminalId = terminalId;

    const payload = {
      venueid: this.VenueID,
      connectedAccountId: localStorage.getItem('RyftSubAccountID') ?? '',
      amount: Math.round(this.paymentAmount * 100),
      currency: (this.CurrencySymbol ?? 'GBP').toLowerCase(),
      terminalId: terminalId,
      method: 'BOOKING',
      identifier: this.scannedBooking.bookingId
    };

    this.http.post<any>(bmxurl + 'StripeTerminalPaymentInit', payload).subscribe({
      next: (response) => {
        if (!response.succeeded) {
          this.showTerminalWaiting = false;
          const detail = response.messages?.[0] ?? 'Failed to initiate terminal payment';

          if (detail.toLowerCase().includes('payment_intent in progress')) {
            this.showTerminalBusyDialog = true;
          } else {
            this.paymentButtonLocked = false;
            this.messageService.add({ severity: 'error', summary: 'Terminal Error', detail });
          }
          return;
        }

        this.terminalPaymentIntentId = response.data?.paymentIntentId ?? response.data?.id ?? '';

        if (this.terminalPaymentIntentId && this.hubConnection) {
          this.hubConnection.on(this.terminalPaymentIntentId, () => {
            this.ngZone.run(() => this.pollScanBookingForPayment());
          });
        }

        //The hub is the fast path; the poll is what catches a notification that never arrives.
        this.terminalPollingIntervalId = setInterval(() => {
          this.ngZone.run(() => this.pollScanBookingForPayment());
        }, 10000);
      },
      error: () => {
        this.showTerminalWaiting = false;
        this.paymentButtonLocked = false;
        this.messageService.add({ severity: 'error', summary: 'Terminal Error', detail: 'Failed to reach terminal payment service' });
      }
    });
  }

  waitForTerminal(): void {
    this.showTerminalBusyDialog = false;
  }

  clearTerminalAndRetryPayment(): void {
    const terminalId = this.pendingTerminalId;
    this.showTerminalBusyDialog = false;

    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.connectTerminalHub(terminalId);
      }
    });
  }

  pollScanBookingForPayment(): void {
    if (this.terminalPaymentResolved || this.scannedBooking == null) { return; }

    this.http.get<any>(bmxurl + 'booking/' + this.VenueID + '/' + this.scannedBooking.bookingId).subscribe({
      next: (response) => {
        if (this.terminalPaymentResolved) { return; }

        const booking = response.data;
        const matched = (booking.payments ?? []).find(
          (p: any) => (p.PaymentId ?? p.intent) === this.terminalPaymentIntentId
        );

        if (matched) {
          this.completeScanAfterPayment(booking);
        }
      },
      error: () => {}
    });
  }

  completeScanAfterPayment(booking: any): void {
    if (this.terminalPaymentResolved) { return; }

    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();

    if (this.terminalPaymentIntentId && this.hubConnection) {
      this.hubConnection.off(this.terminalPaymentIntentId);
    }

    this.showTerminalWaiting = false;
    this.messageService.add({ severity: 'success', summary: 'Paid', detail: 'Payment taken on the card reader.' });
    this.afterScanPayment(booking);
  }

  stopTerminalPolling(): void {
    if (this.terminalPollingIntervalId !== null) {
      clearInterval(this.terminalPollingIntervalId);
      this.terminalPollingIntervalId = null;
    }
  }

  cancelTerminalPayment(): void {
    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();

    if (this.terminalPaymentIntentId && this.hubConnection) {
      this.hubConnection.off(this.terminalPaymentIntentId);
    }

    this.showTerminalWaiting = false;
    this.paymentButtonLocked = false;

    const terminalId = localStorage.getItem("GeneralTerminalName_" + this.VenueID) ?? '';

    this.http.get(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      next: () => {},
      error: () => {}
    });
  }
  //#endregion

  ngOnDestroy() {
    if (this.scanTimer) { clearTimeout(this.scanTimer); }

    //A terminal poll left running would keep hitting the API after the page has gone.
    this.stopTerminalPolling();
  }

  viewCounterBookings(type: string): void {
    this.router.navigateByUrl("/counterbookinglist/" + type);
  }

  bookSession(time){
    //let BookingDateYear = this.BookingDate.getFullYear();
    //let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    //let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    //let NewDate = new Date(BookingDateYear + "-" + BookingDateMonth + "-" + BookingDateDay + " " + time + ":00");

    let BookingDateTime: string = this.BookingDate.getFullYear() + "-" +  ('00' + (Number(this.BookingDate.getMonth()) + 1)).slice(-2) + "-" +  ('00' + this.BookingDate.getDate()).slice(-2)+ "T" + time + ":00";
     
    this.router.navigateByUrl("/booking/0?bookingDate=" + BookingDateTime);
  }

  //A session only runs on its own day. Looking at any other day stops whatever was left started
  //on it - usually a day that has been and gone, where nobody pressed Stop - so a session cannot
  //sit marked as running for ever. The datetime is sent back exactly as the server gave it, so
  //the stop lands on the same session rather than one a timezone away.
  private stopStartedSessions(sessions: session[])
  {
    const started = (sessions ?? []).filter(item => item.started == true && item.id != null);

    if(started.length == 0)
    {
      return;
    }

    let stoppedCount = 0;
    let replies = 0;

    started.forEach(item => {
      const stopped: session = {
        id: item.id,
        venueid: this.VenueID,
        datetime: item.datetime,
        started: false
      };

      this.http.post<any>(bmxurl + "/CountersSession", stopped).subscribe(response => {
        if(response.succeeded)
        {
          item.started = false;
          stoppedCount++;

          (this.bookingnumbers ?? []).filter(bn => bn.id == item.id).forEach(bn => bn.started = false);
        }

        this.afterStoppingSession(++replies, started.length, stoppedCount);
      }, () => {
        this.afterStoppingSession(++replies, started.length, stoppedCount);
      });
    });
  }

  //Once every stop has answered, redraw the list (keeping Show Started as it was) and say what
  //happened once, rather than once per session.
  private afterStoppingSession(replies: number, total: number, stoppedCount: number)
  {
    if(replies < total)
    {
      return;
    }

    this.bookingnumbersfiltered = this.showStarted
      ? this.bookingnumbers
      : this.bookingnumbers.filter(bn => bn.started == false || bn.started == null);

    if(stoppedCount > 0)
    {
      this.messageService.add({severity:'info', summary:'Sessions stopped', detail: stoppedCount + (stoppedCount == 1 ? ' session was' : ' sessions were') + ' still started on a day that is not today, and ' + (stoppedCount == 1 ? 'has' : 'have') + ' been stopped.'});
    }

    if(stoppedCount < total)
    {
      this.messageService.add({severity:'error', summary:'Could not stop sessions', detail: (total - stoppedCount) + ' started ' + (total - stoppedCount == 1 ? 'session' : 'sessions') + ' on this day could not be stopped.'});
    }
  }

  toggleStarted(){
    this.showStarted = !this.showStarted;

    if(this.showStarted)
    {
      this.bookingnumbersfiltered = this.bookingnumbers;
    }
    else
    {
      this.bookingnumbersfiltered = this.bookingnumbers;
      this.bookingnumbersfiltered = this.bookingnumbers.filter(bn => bn.started == false || bn.started == null);
    }
  }

}
